import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { editStudent, deleteStudent } from '../../../../redux';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import { Link, useNavigate } from 'react-router-dom';

function EditStudentForm (props) {
    const navigate = useNavigate();
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        email: "",
        studentId: "",
    });
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    useEffect(() => {
        setState({
            ...state,
            firstName: props.student.firstName,
            lastName: props.student.lastName,
            email: props.student.email,
            studentId: props.student.studentId
        })
    }, []);

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.firstName === "" ||
            state.lastName === "" ||
            state.email === "") {
            setState({
                ...state,
                errMsg: "First name, last name, and email are required fields."
            })
        } else {
            props.editStudent(
                props.student._id,
                {
                    firstName: state.firstName.trim(),
                    lastName: state.lastName.trim(),
                    email: state.email.trim(),
                    studentId: state.studentId.trim()
                },
                props.teacherStudents,
                props.user._id
            );
            navigate("/manage/students")
        }
    }

    const handleDelete = () => {
        props.deleteStudent(
            props.student._id,
            props.teacherStudents,
            props.teacherEvaluations
        );
        navigate("/manage/students");
    }

    return (
        <div className="inputPageContainer dashboard">
            <div className="inputPage">
                <Link to="/manage/students" className="backButton">
                    <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                    Return to Manage Students
                </Link>
                <h1>Edit Student</h1>
                <form onSubmit={handleSubmit}>
                    <TextField
                        hintText="First Name"
                        name="firstName"
                        onChange={handleChange}
                        value={state.firstName}
                    />
                    <br/>
                    <TextField
                        hintText="Last Name"
                        name="lastName"
                        onChange={handleChange}
                        value={state.lastName}
                    />
                    <br/>
                    <TextField
                        hintText="Email"
                        type="email"
                        name="email"
                        onChange={handleChange}
                        value={state.email}
                    />
                    <br/>
                    <TextField
                        hintText="Student ID"
                        onChange={handleChange}
                        value={state.studentId}
                        name="studentId"
                    />
                    <br/>
                    <button type="button" onClick={() => setShowDeleteDialog(true)} className="actionButton" style={{margin: "auto", marginTop: "30px", width: "150px", display: "block"}}>Delete</button>
                    <button type="submit" className="pink saveButton" style={{marginTop: "30px"}}>Submit</button>
                </form>
                <p className="errorMessage">{state.errMsg}</p>
            </div>
            <Dialog open={showDeleteDialog} onRequestClose={() => setShowDeleteDialog(false)}>
                <div>
                    <h3>Are you sure you want to delete this student?</h3>
                    <div style={{display: "flex", justifyContent: "flex-end", padding: "20px 10px", gap: '24px'}}>
                        <button onClick={() => setShowDeleteDialog(false)} className="actionButton">Cancel</button>
                        <button className="actionButton" onClick={() => {
                            handleDelete();
                            setShowDeleteDialog(false);
                        }}>
                            Delete student
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(state => state.root, { editStudent, deleteStudent })(EditStudentForm);
